import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FabricCollection} from '../../../Models/FabricCollection';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute} from '@angular/router';
import {FabricCollectionService} from '../../../Services/fabric-collection.service';
import {Fabric} from '../../../Models/Fabric';
import {FabricService} from '../../../Services/fabric.service';

@Component({
  selector: 'app-view-fabric-collection',
  templateUrl: './view-fabric-collection.component.html',
  styleUrls: ['./view-fabric-collection.component.scss']
})
export class ViewFabricCollectionComponent implements OnInit {
  public fabricCollection: FabricCollection = new FabricCollection();
  public fabrics: Fabric[] = [];
  public fabricId: number;
  public fabricName: string;
  public fabricCollectionId: number;
  public attachedFabrics: number;
  public archive: boolean = true;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private route: ActivatedRoute,
    private fabricCollectionService: FabricCollectionService,
    private fabricService: FabricService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.fabricCollectionId = params['id'];
        this.getFabricCollectionFabrics();
      }
    });
  }

  getFabricCollectionFabrics() {
    this.fabricCollectionService.getFabricsOfFabricCollection(this.fabricCollectionId).subscribe((resp) => {
      this.fabricCollection = resp;
      this.fabrics = resp.fabrics;
      this.attachedFabrics = this.fabrics.length;
      this.archive = true;
    });
  }
  getFabricCollectionArchiveFabrics() {
    this.fabricCollectionService.getArchivedFabricsOfCollection(this.fabricCollectionId).subscribe((resp) => {
      this.fabrics = resp;
      this.attachedFabrics = resp.length;
      this.archive = false;
    });
  }

  setDetailForSoftDelete(id, name) {
    this.deleteModal.show();
    this.fabricId = id;
    this.fabricName = name.bold();
  }

  setDetailForReadd(id, name) {
    this.readdModal.show();
    this.fabricId = id;
    this.fabricName = name.bold();
  }

  softDelete() {
    this.deleteFabricFromCollection();
  }

  readd() {
    this.readdFabricFromCollection();
  }

  deleteFabricFromCollection() {
    this.fabricService.softDeleteFabric(this.fabricId).subscribe((res) => {
      this.getFabricCollectionFabrics();
      this.deleteModal.hide();
    });
  }

  readdFabricFromCollection() {
    this.fabricService.readdFabric(this.fabricId).subscribe((res) => {
      this.getFabricCollectionArchiveFabrics();
      this.readdModal.hide();
    });
  }

  getFabricCollection() {
    return FabricCollection;
  }

  getFabrics() {
    return Fabric;
  }

  setParentPosition(FabricId, positionNumber) {
    const position = {position: positionNumber};
    this.fabricCollectionService.setParentPosition(position, FabricId).subscribe(
      (res) => {
        this.getFabricCollectionFabrics();
      }
    );
  }
}
